import { game } from './index'

// 공통 필터 메서드 적용 
import { checkLimitedUser } from './function/method'

function diceWinList (option) {
  return game.post('dice/winList.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

export { diceWinList }